import React from 'react';
import { Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import { Container } from './styles';
import CreateReusableAsset from './CreateReusableTemplate';
import { CREATE_REUSABLE_ASSET_MODAL } from './translationValues';

const ReusableAssetModal = props => {
  const { onSucess, onCancel, t, type = 'flow', isEmailTemplate = false } = props;
  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={type === 'flow' ? t(CREATE_REUSABLE_ASSET_MODAL.CREATE_REUSABLE_PAGE_TITLE.key, CREATE_REUSABLE_ASSET_MODAL.CREATE_REUSABLE_PAGE_TITLE.value) : t(CREATE_REUSABLE_ASSET_MODAL.CREATE_REUSABLE_SECTION_TITLE.key, CREATE_REUSABLE_ASSET_MODAL.CREATE_REUSABLE_SECTION_TITLE.value)}
        centered
        maskClosable={false}
        visible={true}
        width="625px"
        footer={false}
        className="warning-modal"
        onCancel={onCancel}
      >
        <CreateReusableAsset onSucess={onSucess} type={type} isEmailTemplate={isEmailTemplate} />
      </Modal>
    </Container>
  );
};
export default withTranslation(["CREATE_REUSABLE_ASSET_MODAL"])(ReusableAssetModal);